import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

/** Encendido, apagado o adverso; el texto lo pone quien la usa. */
export type StatusTone = 'active' | 'inactive' | 'danger';

interface StatusIndicatorProps {
  status: StatusTone;
  label: string;
}

const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

const Dot = styled.span<{ color: string }>(({ color }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: color,
}));

const Label = styled.span<{ color: string }>(({ color }) => ({
  fontFamily: t.font,
  fontSize: 13,
  fontWeight: 500,
  color,
}));

/**
 * Primitivo: punto + etiqueta que comunica si un registro está activo.
 */
const TONES = {
  active: { dot: t.color.statusActive, text: t.color.statusActiveText },
  inactive: { dot: t.color.statusInactive, text: t.color.statusInactiveText },
  danger: { dot: t.color.danger, text: t.color.danger },
} as const;

const StatusIndicator = ({ status, label }: StatusIndicatorProps) => {
  const tone = TONES[status];
  return (
    <Row>
      <Dot color={tone.dot} />
      <Label color={tone.text}>{label}</Label>
    </Row>
  );
};

export default StatusIndicator;
